export interface PortraitAssignmentAuditEntry {
  suspectIndex?: number;
  action?: string;
  reason?: string;
  portraitId?: string;
  portraitLabel?: string;
  portraitSlug?: string;
}

export interface PortraitAssignmentIndicator {
  badgeLabel: string;
  badgeClassName: string;
  detail: string;
}

const normalizeMatchReason = (reason: string) => {
  switch (reason) {
    case "exact_age_sex_skin_hair_best_available":
      return "Matched on age, sex, skin tone, and hair.";
    case "exact_age_sex_skin_best_available":
      return "Matched on age, sex, and skin tone.";
    case "exact_age_sex_best_available":
      return "Matched on age and sex.";
    case "llm_generated_after_no_candidate_tier_match":
      return "No acceptable library match. Generated and saved back to the library.";
    default:
      return "";
  }
};

export const resolvePortraitAssignmentIndicator = ({
  suspect,
  suspectIndex,
  auditEntries,
}: {
  suspect: any;
  suspectIndex: number;
  auditEntries?: PortraitAssignmentAuditEntry[] | null;
}): PortraitAssignmentIndicator | null => {
  const auditEntry = Array.isArray(auditEntries)
    ? auditEntries.find((entry) => Number(entry?.suspectIndex) === suspectIndex) || null
    : null;
  const action = String(auditEntry?.action || "").trim().toLowerCase();
  const reason = String(auditEntry?.reason || "").trim();
  const portraitLabel =
    String(auditEntry?.portraitLabel || suspect?.portrait_library_label || suspect?.portraitLibraryLabel || "").trim();
  const hasPortraitLibraryRef = Boolean(
    String(
      suspect?.portrait_library_id ||
        suspect?.portraitLibraryId ||
        suspect?.portrait_library_slug ||
        suspect?.portraitLibrarySlug ||
        ""
    ).trim()
  );

  if (action === "generated") {
    return {
      badgeLabel: "Fallback Generated",
      badgeClassName: "border-amber-300/25 bg-amber-500/10 text-amber-50/90",
      detail: normalizeMatchReason(reason) || "Generated from the suspect description and saved to the library.",
    };
  }

  if (action === "assigned" || hasPortraitLibraryRef) {
    const baseDetail = normalizeMatchReason(reason) || "Matched from the portrait library.";
    return {
      badgeLabel: "Library Match",
      badgeClassName: "border-cyan-300/25 bg-cyan-400/10 text-cyan-50/90",
      detail: portraitLabel ? `${baseDetail} ${portraitLabel}` : baseDetail,
    };
  }

  return null;
};
